import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import WarningIcon from '@mui/icons-material/Warning';

const BANNER_HEIGHT = 42;
const CONTENT_OFFSET = 15;

const styles = {
    wrapper: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1400,
        height: BANNER_HEIGHT,
    },
    banner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        backgroundColor: '#fff3e0',
        borderBottom: '2px solid #ff9800',
        padding: '8px 24px',
        height: BANNER_HEIGHT,
        boxSizing: 'border-box',
    },
    text: {
        color: '#e65100',
        fontWeight: 500,
        fontSize: 14,
    },
    button: {
        backgroundColor: '#ff9800',
        color: '#fff',
        textTransform: 'none',
        fontWeight: 600,
        fontSize: 12,
        padding: '4px 16px',
        '&:hover': {
            backgroundColor: '#f57c00',
        },
    },
    icon: {
        color: '#e65100',
        fontSize: 20,
    },
    urgent: {
        backgroundColor: '#ffebee',
        borderBottom: '2px solid #f44336',
    },
    urgentText: {
        color: '#c62828',
    },
    urgentIcon: {
        color: '#f44336',
    },
};

class TrialBanner extends Component {
    getDaysRemaining() {
        const { userSession } = this.props;
        if (!userSession || !userSession.user) return null;

        const isShared = userSession.user.isshared ?? userSession.user.is_shared ?? userSession.user.isShared;
        const contractStatusId = userSession.user.contractstatusid ?? userSession.user.contractStatusId ?? userSession.user.contract_status_id;
        if (!isShared && contractStatusId != 5 && contractStatusId !== '5') return null;

        const trialEndDate = userSession.user.trialenddate ?? userSession.user.trialEndDate ?? userSession.user.trial_end_date;
        if (!trialEndDate) return null;

        const end = new Date(trialEndDate);
        const now = new Date();
        const diffMs = end - now;
        const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

        return diffDays;
    }

    render() {
        const { classes } = this.props;
        const daysRemaining = this.getDaysRemaining();

        if (daysRemaining === null) return null;

        const isUrgent = daysRemaining <= 3;
        const isExpired = daysRemaining <= 0;

        return (
            <>
                <style>{`
                    .MuiAppBar-positionFixed { top: ${BANNER_HEIGHT}px !important; }
                    .MuiDrawer-root .MuiDrawer-paper { top: ${BANNER_HEIGHT}px !important; height: calc(100% - ${BANNER_HEIGHT}px) !important; }
                    .MuiDrawer-root .MuiDrawer-paperAnchorDockedLeft { top: ${BANNER_HEIGHT}px !important; height: calc(100% - ${BANNER_HEIGHT}px) !important; }
                    main > div:first-child { margin-top: ${CONTENT_OFFSET}px !important; }
                `}</style>
                <div className={classes.wrapper}>
                    <div className={`${classes.banner} ${isUrgent ? classes.urgent : ''}`}>
                        <WarningIcon className={isUrgent ? classes.urgentIcon : classes.icon} />
                        <Typography className={`${classes.text} ${isUrgent ? classes.urgentText : ''}`}>
                            {isExpired
                                ? 'Seu período de avaliação expirou.'
                                : `Você está em período de avaliação. ${daysRemaining} dia${daysRemaining !== 1 ? 's' : ''} restante${daysRemaining !== 1 ? 's' : ''}.`
                            }
                        </Typography>
                        <Button
                            variant="contained"
                            size="small"
                            className={classes.button}
                            onClick={() => this.props.history.push(`/${this.props.match?.params?.lang || window.location.pathname.split('/')[1]}/subscription-management`)}
                        >
                            {isExpired ? 'Assinar Agora' : 'Gerenciar Assinatura'}
                        </Button>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = state => ({
    userSession: state.userSession,
});

export default withRouter(injectIntl(connect(mapStateToProps)(withStyles(styles)(TrialBanner))));
